import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import {
  ReadDisabilityCertificate,
  WriteDisabilityCertificate,
} from "@/types/disabilityCertificate";

export const DisabilityCertificateService = new APIService<
  ReadDisabilityCertificate,
  WriteDisabilityCertificate
>(API.DisabilityCertificates);
export const fetchDisabilityCertificateList =
  DisabilityCertificateService.getList;
export const fetchDisabilityCertificate = DisabilityCertificateService.get;
export const createDisabilityCertificate = DisabilityCertificateService.post;
export const updateDisabilityCertificate = DisabilityCertificateService.patch;
